<template>
  <v-item-group
    mandatory
    :value="selected"
    @change="$emit('update:selected', $event); validator.$touch();"
  >
    <v-container>
      <v-row>
        <v-col
          v-for="item in items"
          :key="item.nr"
          class="shrink"
        >
          <v-item
            v-slot:default="{ active, toggle }"
            :value="item.nr"
          >
            <v-card
              :color="active ? 'primary' : 'white'"
              class="item-group-card d-flex align-center text-center"
              :dark="active"
              height="100%"
              width="175px"
              @click="toggle"
            >
              <v-container>
                <v-row class="align-space-between">
                  <v-col cols="12">
                    <v-icon size="4rem">
                      {{ item.icon }}
                    </v-icon>
                  </v-col>
                  <v-col cols="12">
                    <label class="text-subtitle-2 text-uppercase">{{ $t(translation + '.' + item.nr) }}</label>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-item>
        </v-col>
      </v-row>
    </v-container>
  </v-item-group>
</template>

<script>
  export default {
    props: {
      selected: {
        type: [Number, String],
        default: '',
        required: true
      },
      items: {
        type: Array,
        default: function () {
          return []
        },
        required: true
      },
      translation: {
        type: String,
        default: ''
      },
      validator: {
        type: Object,
        default: function () {
          return {}
        },
        required: true
      }
    }
  }
</script>

<style>
    .item-group-card {
        transition: transform 300ms ease;
    }
    .item-group-card.v-item--active {
        transform: scale(1.05, 1.05);
    }
</style>
